import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var SampleTech = {
  PARSE: 'parse',
  '10X': '10x',
  RHAPSODY: 'rhapsody',
  SEURAT: 'seurat',
  H5: '10x_h5'
};
var techNamesToDisplay = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SampleTech['10X'], "10X Chromium".concat(String.fromCharCode(8482))), SampleTech.RHAPSODY, "BD Rhapsody".concat(String.fromCharCode(8482))), SampleTech.SEURAT, 'Seurat'), SampleTech.H5, "10X Chromium".concat(String.fromCharCode(8482), " - H5")), SampleTech.PARSE, "Parse Evercode".concat(String.fromCharCode(8482), " WT"));
var metadataValuesByTechnology = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SampleTech.PARSE, 'Parse Evercode WT'), SampleTech['10X'], '10X Chromium'), SampleTech.RHAPSODY, 'BD Rhapsody'), SampleTech.SEURAT, 'Seurat'), SampleTech.H5, '10X Chromium - H5');
var getTechNameToDisplay = function getTechNameToDisplay(tech) {
  return techNamesToDisplay[tech];
};
var getSampleTechMetadataValue = function getSampleTechMetadataValue(tech) {
  return metadataValuesByTechnology[tech];
};
export default SampleTech;
export { getTechNameToDisplay, getSampleTechMetadataValue };